<template>
  <div>
    <!-- 头部logo -->
    <head-tou />
    <!-- 导航栏 -->
    <div class="navigation">
      <div class="minbox">执业药师继续教育课程选择</div>
    </div>
    <div class="w">
      <div class="tabs">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="食品培训（专业科目20门）" name="first">
            <!-- 商品 -->
            <van-list
              v-model="loading"
              :finished="finished"
              finished-text="没有更多了"
            >
              <div class="purchase">
                <van-checkbox shape="square" v-model="checked"></van-checkbox>
<!--                <img class="img" src="@/assets/1002061.jpg" alt="" />-->
                <span class="span">食品安全培训从业人员</span>
                <span class="span1"
                  >职称/单位：双证执业药师 授课老师：林林林 学时：7课时</span
                >
              </div>
            </van-list>
          </el-tab-pane>
          <el-tab-pane label="药师培训（专业科目18门）" name="second"
            >配置管理</el-tab-pane
          >
        </el-tabs>
        <div></div>
      </div>
    </div>
    <!-- 结算 -->
    <div class="buttona">
      <el-button @click="dialogVisible = true">微信支付</el-button>
      <span>共计：￥220</span>
      <span>可选 5 门功课学习，已选 2 门 </span>
    </div>
    <!-- 结算弹出框 -->
    <el-dialog
      :visible.sync="dialogVisible"
      width="15%"
    >
      <div class="sao">扫一扫付款 (元)</div>
      <div class="yuan">￥220</div>
      <img class="img1" src="@/assets/zhifu.jpg" alt="" />
      <img class="img2" src="@/assets/weixin.png" alt="" />
      <div class="wei">微信支付</div>
    </el-dialog>
    <!-- 底部 -->
    <navigation-button />
  </div>
</template>

<script>
import HeadTou from "@/components/hard.vue";
import NavigationButton from "@/components/navigationbutton.vue";
export default {
  name: "purchase",
  components: {
    HeadTou,
    NavigationButton,
  },
  data() {
    return {
      activeName: "first",
      //   复选框
      checked: false,
      loading: false,
      finished: false,
      //   结算弹出框显示与隐藏
      dialogVisible: false,
    };
  },
  methods: {
    handleClick(tab, event) {
      // console.log(tab, event);
    },
  },
};
</script>

<style lang="less" scoped>
.navigation {
  width: 100%;
  height: 100px;
  background: #2aa9b5;
  .minbox {
    width: 1200px;
    margin: auto;
    height: 100px;
    background: #2aa9b5;
    font-size: 17px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    line-height: 100px;
  }
}
.w {
  width: 1200px;
  height: 900px;
  margin: auto;
  .tabs {
    .purchase {
      position: relative;
      top: 20px;
      height: 119px;
      .van-checkbox {
        display: inline-block;
        margin: 24px;
      }
      .span {
        position: absolute;
        font-size: 19px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #000000;
      }
      .span1 {
        width: 402px;
        height: 16px;
        font-size: 15px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #9a9a9a;
      }
      .img {
        width: 69px;
        height: 69px;
        margin-right: 20px;
      }
    }
  }
}

/deep/.el-tabs__item {
  width: 600px;
  text-align: center;
  line-height: 65px;
  height: 65px;
  font-size: 19px;
  font-family: PingFang SC;
  font-weight: 500;
}
.buttona {
  height: 84px;
  background: #eeeeee;
  .el-button {
    float: right;
    margin: 17px 0px 17px 24px;
    margin-right: 20%;
    background: #d8261c;
    border-radius: 7px;
    font-size: 18px;
    font-family: PingFang SC;
    color: #ffffff;
    line-height: 25px;
  }
  span {
    float: right;
    line-height: 84px;
    margin: 0 20px 0 10px;
  }
}
.img1 {
  width: 200px;
  height: 200px;
  position: relative;
  left: 50%;
  transform: translate(-50%);
}
.img2 {
  width: 22px;
  height: 19px;
  position: relative;
  top: 23px;
  right: 50%;
}
.sao {
  text-align: center;
}
.yuan {
  text-align: center;
}
.wei {
  text-align: center;
  margin-left: 30px;
}
</style>
